export default "__VITE_ASSET__DMJY1NiZ__"